import { gql } from '@apollo/client';
import { z } from 'zod';

import { IBasicAddress, IBasicAddressWithCoordinates } from '../../utils/addresses';

export const addressSchema = z.object({
    address1: z.string(),
    address2: z.string(),
    city: z.string(),
    state: z.string(),
    zip_code: z.string(),
});
export type Address = z.infer<typeof addressSchema>;
export const zodAddressFromBasicAddress = (address: IBasicAddress): Address => {
    return {
        address1: address.line1,
        address2: address.line2,
        city: address.city,
        state: address.state,
        zip_code: address.zipCode,
    };
};

export const addressForVisitRequestSchema = z.object({
    address1: z.string(),
    address2: z.string().nullable(),
    city: z.string(),
    state: z.string(),
    zipCode: z.string(),
});
export type AddressForVisitRequest = z.infer<typeof addressForVisitRequestSchema>;

export const addressWithLatLngSchema = addressSchema.extend({
    uuid: z.string().uuid(),
    lat: z.string().nullable(),
    lng: z.string().nullable(),
});
export type AddressWithLatLng = z.infer<typeof addressWithLatLngSchema>;
export const zodAddressWithLatLngFromBasicAddressWithCoordinates = (
    address: IBasicAddressWithCoordinates,
): AddressWithLatLng => {
    return {
        uuid: address.id,
        address1: address.line1,
        address2: address.line2,
        city: address.city,
        state: address.state,
        zip_code: address.zipCode,
        lat: address.coordinates?.latitude ?? null,
        lng: address.coordinates?.longitude ?? null,
    };
};

export const AddressWithLatLngFragment = gql`
    fragment AddressWithLatLngFragment on Address {
        id
        line1
        line2
        city
        state
        zipCode
        coordinates {
            latitude
            longitude
        }
    }
`;
export interface IAddressWithLatLngFragment {
    id: string;
    line1: string;
    line2: string;
    city: string;
    state: string;
    zipCode: string;
    coordinates: {
        latitude: string;
        longitude: string;
    } | null;
}

export const gqlAddressWithLatLngToZod = ({
    id,
    line1,
    line2,
    city,
    state,
    zipCode,
    coordinates,
}: IAddressWithLatLngFragment): AddressWithLatLng => {
    return {
        uuid: id,
        address1: line1,
        address2: line2,
        city,
        state,
        zip_code: zipCode,
        lat: coordinates?.latitude ?? null,
        lng: coordinates?.longitude ?? null,
    };
};
